import React from "react";

const Section = ({ title, children }) => (
  <div className="bg-white p-6 rounded-2xl shadow-md space-y-3">
    <h2 className="text-2xl font-semibold text-gray-800">{title}</h2>
    <div className="text-gray-700 text-sm md:text-base space-y-2">
      {children}
    </div>
  </div>
);

const TermsOfUse = () => {
  return (
   <div style={{ background: "#f8fafc", minHeight: "100vh", padding: "40px 16px" }}>
  <div style={{ maxWidth: "1000px", margin: "0 auto" }}>

        <h1 className="text-4xl font-bold text-center text-gray-900">
          Terms of Use
        </h1>

        <p style={{ marginBottom: "20px" }}>
  Client Exchange is operated by Client Exchange Pty Ltd (ABN 23 692 732 157).
</p>

      <p className="text-lg text-center text-gray-700">
        These Terms of Use govern access to and use of Client Exchange™.
        By creating an account or using the platform, you agree to these terms.
      </p>

      <Section title="1. Platform Nature">
        <p>
          Client Exchange™ is an independent online marketplace that facilitates
          introductions and structured payment processing between verified
          businesses.
        </p>
        <p>
          Client Exchange™ is not a broker, agent, franchisor, employer,
          financial adviser, or party to any underlying service agreement.
        </p>
        <p>
  Client Exchange™ does not act as an agent, trustee, or representative of any user.
</p>
<p>
  Client Exchange™ does not verify or guarantee the quality, reliability, or
  performance of any business or client listing.
</p>
      </Section>

      <p>
  Client Exchange™ does not provide, arrange, or supply any cleaning, lawn mowing, pool care, or related services, and does not employ or engage contractors to perform such services.
</p>

      <Section title="2. Eligibility & Verification">
        <p>
          Users must provide accurate business information, including ABN and
          identity verification where required.
        </p>
        <p>
  Users warrant that any ABN, business name, trading name, or business
  information submitted belongs to them or that they are authorised to
  act on behalf of that business.
</p>
        <p>
  Providing false or misleading information may result in suspension
  or termination of access.
</p>

<p>
  Client Exchange™ uses a third-party identity verification provider to assist in confirming user identity.
</p>

<p>
  Verification may require users to submit a government-issued identification document (such as a driver’s licence or passport) and, where required, a selfie or biometric check.
</p>

<p>
  Client Exchange™ does not collect, access, or store identity documents directly. All identity verification processes are performed securely by the third-party provider.
</p>

<p>
  Client Exchange™ retains only the verification outcome (e.g. verified / not verified) and a corresponding reference ID associated with the verification session.
</p>

<p>
  Client Exchange™ is a technology platform and does not guarantee the accuracy, authenticity, or ongoing validity of any user’s identity.
</p>

<p>
  Users acknowledge that verification results are provided by third-party services, and Client Exchange™ is not responsible for errors, omissions, or fraudulent activity that may occur despite verification.
        </p>
        <p>
  Client Exchange™ reserves the right to restrict, suspend, or terminate access where verification requirements are not satisfied or where verification results indicate potential risk or non-compliance.
</p>
      </Section>

      <Section title="3. Listings & Representations">
  <p>
    Users are solely responsible for the accuracy of listing information,
    including pricing, service frequency, and client details.
  </p>

  <p>
    Client Exchange™ does not verify revenue claims, service performance,
    or future income projections.
  </p>

  <p>
    Listings may be anonymised and limited in detail prior to contact release.
  </p>

  <p>
    Buyers acknowledge that they must conduct their own independent due diligence
    after receiving seller contact details and before completing any off-platform
    agreement or relying on the information provided.
  </p>

  <p>
    Buyers must not rely solely on any listing, representation, or information
    provided on the platform.
  </p>
</Section>

      <Section title="4. Payments">
        <p>
          All payments must be processed through the platform’s designated
          payment provider.
        </p>
        <p>
  Client Exchange™ does not hold itself out as a trustee of funds
  beyond the technical payment processing workflow.
</p>

<p>
  All payments are processed through a third-party payment provider. Client
  Exchange™ does not control, operate, or guarantee the availability of payment
  processing systems.
</p>
<p>
  Client Exchange™ uses Stripe and Stripe Connect for payment processing,
  seller onboarding, payout management, and related compliance services.
  Certain business, identity, and payment-related information submitted
  through Stripe may be accessible to Client Exchange™ where reasonably
  required for payment operations, fraud prevention, compliance,
  marketplace safety, dispute handling, or customer support.
</p>

<p>
  Client Exchange™ is not responsible for payment delays, failures, chargebacks,
  reversals, or errors caused by third-party payment providers.

        </p>
      </Section>

      <Section title="5. Handover Confirmation">
        <p>
          Handover is completed only when both participating businesses confirm
          within the platform that the client introduction and transfer have
          occurred.
        </p>
        <p>
          Confirmation signifies acceptance of the transfer as complete.
        </p>
        <p>
  Client Exchange™ does not verify, guarantee, or warrant the quality,
  accuracy, or ongoing performance of any transferred clients or business
  following handover.
</p>
      </Section>

      <Section title="6. No Guarantee of Income or Retention">
        <p>
          Client Exchange™ does not guarantee client retention, service
          continuity, future income, or business performance.
        </p>
        <p>
          All business decisions are made at the user’s own discretion and risk.
        </p>
      </Section>

     <Section title="7. Limitation of Liability">
  <p>
    To the maximum extent permitted by law, Client Exchange™ is not liable for
    any indirect, incidental, consequential, or economic loss arising from use
    of the platform.
  </p>
  <p>
    This includes, but is not limited to, loss of income, loss of business,
    loss of clients, loss of opportunity, or any expected future revenue.
  </p>
  <p>
    Client Exchange™ facilitates introductions and payment processing between
    businesses but does not participate in the underlying service agreement
    between contractors and their clients.
  </p>
  <p>
    Any disputes relating to transferred clients or business performance are
    solely between the participating businesses.
  </p>

  <p>
  To the maximum extent permitted by law, the total liability of Client Exchange™
  arising out of or in connection with the use of the platform is limited to the
  total fees paid by the user to Client Exchange™ in the preceding 3 months.
</p>
</Section>

<Section title="8. Dispute Resolution">
  <p>
    Client Exchange™ is a technology platform that facilitates introductions and
    structured transactions between independent businesses. Client Exchange™
    is not a party to any agreement between users.
  </p>
  <p>
    In the event of a dispute between users, the parties must attempt to resolve
    the matter directly between themselves.
  </p>
  
   <p>
  Client Exchange™ does not provide legal advice, mediation,
  arbitration, or formal dispute resolution services between users.
</p>
  
  <p>
    Client Exchange™ may, at its discretion, review account activity or platform
    usage in connection with a dispute.
  </p>
  <p>
    Refunds may be issued only in limited circumstances relating to platform
    processes (for example, where a required payment is not completed and a
    transaction cannot proceed). Client Exchange™ is under no obligation to
    provide refunds for disputes relating to client performance, service
    outcomes, or agreements between users.
  </p>
</Section>

      <Section title="9. Suspension & Termination">
        <p>
          Client Exchange™ reserves the right to suspend or terminate accounts
          for misconduct, misuse of the platform, or breach of these Terms.
        </p>
      </Section>

      <Section title="10. Governing Law">
        
        <p>
          These Terms are governed by the laws of Australia.
        </p>
      </Section>

      <Section title="11. Indemnity">
  <p>
    You agree to indemnify, defend, and hold harmless Client Exchange™,
    its directors, officers, employees, and affiliates from and against
    any and all claims, losses, damages, liabilities, costs, and expenses
    (including legal fees) arising out of or in connection with:
  </p>
  <p>(a) any false, misleading, or inaccurate listing information provided by you;</p>
  <p>(b) any breach of these Terms;</p>
  <p>(c) any dispute between you and another user;</p>
  <p>(d) any transfer, attempted transfer, or failure of transfer of clients or business.</p>
  <p>This indemnity survives termination of your account and use of the platform.</p>
</Section>

      <p className="text-center text-gray-800 font-semibold text-lg">
        Continued use of Client Exchange™ constitutes acceptance of these Terms.
      </p>

      <Section title="12. Platform Circumvention">
  <p>
    Users must not use Client Exchange™ to identify, contact, solicit,
    or transact with another user for the purpose of avoiding platform
    fees, payment processes, verification requirements, or other platform
    protections.
  </p>

  <p>
    Any introduction, listing, client opportunity, or business connection
    first identified through Client Exchange™ is deemed to originate from
    the platform.
  </p>

  <p>
    Users must not:
  </p>

  <p>
    (a) encourage another user to complete transactions outside the platform;
  </p>

  <p>
    (b) exchange contact details for the purpose of avoiding platform fees;
  </p>

  <p>
    (c) request or accept direct payment outside the platform where the
    transaction originated through Client Exchange™; or
  </p>

  <p>
    (d) attempt to bypass platform processes, protections, or payment workflows.
  </p>

  <p>
    Client Exchange™ reserves the right to suspend or terminate accounts
    engaged in fee circumvention or off-platform transaction activity.
  </p>
</Section>

<Section title="13. Acceptable Use">
  <p>
    Users must use Client Exchange™ lawfully, honestly, and in good faith.
  </p>

  <p>
    Users must not:
  </p>

  <p>
    (a) post false, misleading, deceptive, or fraudulent listings;
  </p>

  <p>
    (b) impersonate another business or individual;
  </p>

  <p>
    (c) upload malicious software, scripts, bots, or automated tools;
  </p>

  <p>
    (d) scrape, harvest, copy, or extract platform data without written permission;
  </p>

  <p>
    (e) interfere with platform functionality or security;
  </p>

  <p>
    (f) harass, abuse, threaten, or intimidate other users; or
  </p>

  <p>
    (g) engage in conduct that may damage the reputation or operation
    of Client Exchange™.
  </p>

  <p>
    Client Exchange™ may remove content, restrict access, suspend accounts,
    or terminate access where misuse or prohibited conduct is suspected.
  </p>
</Section>

<Section title="14. Handover & Payment Release">
  <p>
    Client Exchange™ provides a structured payment and handover workflow
    solely as a technology feature of the platform.
  </p>

  <p>
    Handover confirmation represents acknowledgment by participating users
    that:
  </p>

  <p>
    (a) a client introduction or transfer has occurred; and
  </p>

  <p>
    (b) the transaction may proceed to payment release in accordance with
    platform processes.
  </p>

  <p>
    Users acknowledge that:
  </p>

  <p>
    (a) Client Exchange™ does not independently verify the quality,
    accuracy, completeness, retention, value, or ongoing performance
    of transferred clients;
  </p>

  <p>
    (b) client retention and future revenue cannot be guaranteed;
  </p>

  <p>
    (c) payment release does not constitute legal determination of
    satisfactory performance; and
  </p>

  <p>
    (d) platform workflows are administrative only and do not constitute
    escrow, trustee, fiduciary, brokerage, or legal services.
  </p>

  <p>
    Client Exchange™ may, at its discretion:
  </p>

  <p>
    (a) delay payment release;
  </p>

  <p>
    (b) request additional information;
  </p>

  <p>
    (c) temporarily restrict accounts; or
  </p>

  <p>
    (d) investigate suspected fraud, misuse, or unusual transaction activity.
  </p>
</Section>

<Section title="15. Refunds & Payment Disputes">
  <p>
    Except where required by law, fees paid through Client Exchange™
    are non-refundable.
  </p>

  <p>
    Refund requests relating to:
  </p>

  <p>
    (a) client retention;
  </p>

  <p>
    (b) business performance;
  </p>

  <p>
    (c) revenue outcomes;
  </p>

  <p>
    (d) service quality; or
  </p>

  <p>
    (e) disputes between users
  </p>

  <p>
    will generally not be accepted.
  </p>

  <p>
    Client Exchange™ may consider refunds only where:
  </p>

  <p>
    (a) duplicate payments occur;
  </p>

  <p>
    (b) platform processing errors occur; or
  </p>

  <p>
    (c) a transaction cannot proceed due to a platform-related failure.
  </p>

  <p>
  Where seller contact details or transaction information have already
  been released to a buyer, Client Exchange™ may retain platform
  administration or service fees even if a transaction does not proceed,
  including where a seller later withdraws or fails to complete a transfer.
</p>

  <p>
    Users acknowledge that chargebacks, payment reversals, or disputes
    initiated through financial institutions or payment providers may
    result in account restriction, payout suspension, or permanent
    platform suspension.
  </p>
</Section>



<Section title="16. Platform Fees & Pricing">
  <p>
    Client Exchange™ may introduce, modify, remove, or vary:
  </p>

  <p>
    (a) platform fees;
  </p>

  <p>
    (b) listing fees;
  </p>

  <p>
    (c) success fees;
  </p>

  <p>
    (d) subscription pricing;
  </p>

  <p>
    (e) transaction fees; or
  </p>

  <p>
    (f) optional service pricing
  </p>

  <p>
    at any time on reasonable notice.
  </p>

  <p>
    Continued use of the platform following updated pricing constitutes
    acceptance of the revised fees.
  </p>

  <p>
    Unless otherwise stated, all fees are expressed in Australian Dollars
    (AUD) and may include GST where applicable.
  </p>

  <p>
    Users are responsible for their own taxation obligations arising
    from use of the platform.
  </p>
</Section>

<Section title="17. Suspension, Restriction & Investigations">
  <p>
    Client Exchange™ reserves the right, at its sole discretion, to:
  </p>

  <p>
    (a) suspend or terminate accounts;
  </p>

  <p>
    (b) remove listings or content;
  </p>

  <p>
    (c) restrict platform access;
  </p>

  <p>
    (d) delay or pause payouts;
  </p>

  <p>
    (e) require additional verification; or
  </p>

  <p>
    (f) investigate account activity
  </p>

  <p>
    where Client Exchange™ reasonably suspects:
  </p>

  <p>
    (a) fraud;
  </p>

  <p>
    (b) misleading conduct;
  </p>

  <p>
    (c) platform misuse;
  </p>

  <p>
    (d) security risks;
  </p>

  <p>
    (e) unlawful activity; or
  </p>

  <p>
    (f) breach of these Terms.
  </p>

  <p>
    Client Exchange™ is not liable for losses arising from account
    suspension, investigation, restriction, or termination undertaken
    in good faith for marketplace integrity, fraud prevention, compliance,
    or security purposes.
  </p>
</Section>

<Section title="18. User Disputes & Platform Review">
  <p>
    Client Exchange™ is not a party to agreements between users and does
    not guarantee the performance of any user, client, or transaction.
  </p>

  <p>
    Users are solely responsible for resolving disputes directly between
    themselves.
  </p>

  <p>
    However, Client Exchange™ may, at its discretion:
  </p>

  <p>
    (a) review account activity;
  </p>

  <p>
    (b) review transaction records;
  </p>

  <p>
    (c) request information from users;
  </p>

  <p>
    (d) temporarily pause payment release;
  </p>

  <p>
    (e) restrict platform access; or
  </p>

  <p>
    (f) investigate suspected misuse, fraud, or breaches of these Terms.
  </p>

  <p>
    Any assistance, investigation, review, or platform action undertaken
    by Client Exchange™ does not constitute acceptance of responsibility
    for the underlying dispute or transaction outcome.
  </p>
</Section>

<Section title="19. Intellectual Property">
  <p>
    Client Exchange™, including its platform, software, branding,
    logos, design, text, graphics, workflows, databases, and content,
    is owned by or licensed to Client Exchange Pty Ltd and protected
    by applicable intellectual property laws.
  </p>

  <p>
    Users must not copy, reproduce, modify, distribute, scrape,
    reverse engineer, republish, or commercially exploit any part
    of the platform without prior written consent.
  </p>

  <p>
    Use of the platform does not transfer any intellectual property
    rights to users.
  </p>
</Section>
         </div>
    </div>
  );
};
export default TermsOfUse;